import { Outlet, Link, createRootRoute, HeadContent, Scripts, redirect } from "@tanstack/react-router";
import { AuthProvider } from "@/lib/auth-context";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import { VisitTracker } from "@/lib/visit-tracker";

import appCss from "../styles.css?url";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">Sayfa bulunamadı</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Aradığınız sayfa mevcut değil ya da taşınmış olabilir.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Ana sayfa
          </Link>
        </div>
      </div>
    </div>
  );
}

// Site kapalı: yalnızca ana sayfa (KAPATTIK), giriş ve admin paneli açık.
const OPEN_PREFIXES = ["/harikaradmin", "/login"];

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const path = location.pathname;
    if (path === "/" || OPEN_PREFIXES.some((p) => path === p || path.startsWith(p + "/"))) {
      return;
    }
    throw redirect({ to: "/" });
  },
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "JUËN" },
      { name: "description", content: "JUËN — üyelik, etkinlik biletleri ve mekan erişimi." },
      { property: "og:title", content: "JUËN" },
      { name: "twitter:title", content: "JUËN" },
      { property: "og:description", content: "JUËN — üyelik, etkinlik biletleri ve mekan erişimi." },
      { name: "twitter:description", content: "JUËN — üyelik, etkinlik biletleri ve mekan erişimi." },
      { property: "og:image", content: "https://storage.googleapis.com/gpt-engineer-file-uploads/xCycN7peJfZewFaJunGFPbUvW2T2/social-images/social-1777042688510-JU.webp" },
      { name: "twitter:image", content: "https://storage.googleapis.com/gpt-engineer-file-uploads/xCycN7peJfZewFaJunGFPbUvW2T2/social-images/social-1777042688510-JU.webp" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:type", content: "website" },
    ],
    links: [
      { rel: "stylesheet", href: appCss },
      { rel: "icon", type: "image/png", href: "/favicon.png" },
    ],
  }),
  shellComponent: RootShell,
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootShell({ children }: { children: React.ReactNode }) {
  return (
    <html lang="tr">
      <head>
        <HeadContent />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}

function RootComponent() {
  return (
    <I18nProvider>
      <AuthProvider>
        <VisitTracker />
        <Outlet />
        <Toaster />
      </AuthProvider>
    </I18nProvider>
  );
}
